import styled from 'styled-components';
import { Modal } from 'ggApp/modules/modal/components/v3';

const MODAL_CONTAINER_CLASS_NAME = 'swapCheckoutModalContainer';
const MODAL_CONTENT_CLASS_NAME = 'swapCheckoutModalContent';

export const SwapModal = styled(Modal).attrs({
    classNames: {
        container: MODAL_CONTAINER_CLASS_NAME,
        content: MODAL_CONTENT_CLASS_NAME,
    },
})`
    & .${MODAL_CONTAINER_CLASS_NAME} {
        display: flex;
        max-width: 384px;
        min-height: 60vh;

        ${({ theme }) => theme.superQuery.minWidth.tabletMin.and.minWidth.desktopMin.css`
            max-height: 90vh;
        `}
    }

    & .${MODAL_CONTENT_CLASS_NAME} {
        display: flex;
        padding: 32px 16px 24px;
        flex-direction: column;

        > *:not(:last-child) {
            display: flex;
            flex: 1 0 100%;
            flex-direction: column;
        }
    }
`;
